<template>
  <FileFolderTabs :tabs="tabs" :current="current" />
</template>

<script>
export default {
  props: {
    routeName: { type: String, default: "training.history.index" },
    routeVars: { type: Object, default: () => {} },
    current: { type: String, default: "" },
    showEvents: { type: Boolean, default: false },
  },
  computed: {
    tabs() {
      let menu = [
        {
          label: "Online",
          icon: "online",
          url: this.route(
            this.routeName,
            _.merge(this.routeVars, { type: "online" })
          ),
        },
        {
          label: "Classroom",
          icon: "classroom",
          url: this.route(
            this.routeName,
            _.merge(this.routeVars, { type: "classroom" })
          ),
        },
      ];
      if (this.showEvents && (this.$root.isAdminager || this.$root.isExternalTrainer)) {
        menu.push({
          label: "Events",
          icon: "calendar",
          url: this.route(
            this.routeName,
            _.merge(this.routeVars, { type: "events" })
          ),
        });
      }
      menu.push({
        label: "Learning Paths",
        icon: "grad-cap",
        url: this.route(
          this.routeName,
          _.merge(this.routeVars, { type: "learning-paths" })
        ),
      });
      return menu;
    },
  },
};
</script>